import React, { Component } from "react";
import "./MenuData.less";
import http from "../../../utils/api";
import { Tabs } from "antd";
import EditNotice from "../EditNotice";
import ApproveList from "../ApproveList";
import ApproveProjectList from "../ApproveProjectList";
import UploadFile from "../UploadFile/UploadFile";
const { TabPane } = Tabs;

class MenuData extends Component {
  render() {
    return (
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{
          height: "70px",
          display: "flex",
          alignItems: "center",
          paddingLeft: "50px"
        }}
      >
        <TabPane tab="上传资料" key="4">
          <UploadFile></UploadFile>
        </TabPane>
      </Tabs>
    );
  }
}

export default MenuData;
